/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Protestant_Religion25Inputs */

const en__field_enum_subject_protestant_religion25 = /** @type {(inputs: _Field_Enum_Subject_Protestant_Religion25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protestant Religion`)
};

const de__field_enum_subject_protestant_religion25 = /** @type {(inputs: _Field_Enum_Subject_Protestant_Religion25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evangelische Religion`)
};

/**
* | output |
* | --- |
* | "Protestant Religion" |
*
* @param {_Field_Enum_Subject_Protestant_Religion25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_protestant_religion25 = /** @type {((inputs?: _Field_Enum_Subject_Protestant_Religion25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Protestant_Religion25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_protestant_religion25(inputs)
	return de__field_enum_subject_protestant_religion25(inputs)
});
export { _field_enum_subject_protestant_religion25 as "_field_enum_SUBJECT_PROTESTANT_RELIGION" }